export const APP_UPDATED = JSON.stringify({
	type: 'APP_UPDATED',
})
